import { Button } from '@elements/button'
import { Link } from '@elements/link'

export function ExternalTicketButton({ href }: { href: string }) {
  return (
    <div className='px-3'>
      <Link href={href} className='w-full' target='_blank' rel='noreferrer'>
        <Button.Primary className='w-full !text-base' sm>
          Get Tickets
        </Button.Primary>
      </Link>
    </div>
  )
}
